import React from 'react';

import './LoadingSpinner.css';

export const LoadingSpinner = () => {
  return <div className="loading"><img src="images/loading.svg" width={100} height={100} alt="Loading"/></div>;
};
